import { Button } from '@/components/atoms/Button/Button'
import { useModal } from '@/hooks/useModal'
import { useTranslation } from 'react-i18next'
import { DialogFormContactUsModal } from './components/DialogFormContactUsModal/DialogFormContactUsModal'

export function ButtonContactUsModal (): JSX.Element {
  const [isOpenDialog, openModal, closeModal] = useModal(false)
  const { t } = useTranslation()
  return (
    <div>
      <Button className='uppercase' onClick={openModal}>{t('header.buttonGetStarted')}</Button>
      {
        isOpenDialog &&
          <DialogFormContactUsModal
            isOpenDialog={isOpenDialog}
            closeDialog={closeModal}
          />
      }
    </div>
  )
}
